import React from "react";
import { SITE } from "../site.config";

/**
 * WhatsApp image button - pill shaped (320x72 native).
 * Variants:
 *  - 'hero'   : large prominent CTA (h-14 ≈ 56px)
 *  - 'inline' : medium inline (h-12 ≈ 48px)
 *  - 'sm'     : small (h-10 ≈ 40px)
 *  - 'block'  : full width, fills container width
 */
export default function WhatsAppButton({
  variant = "inline",
  className = "",
  testId = "whatsapp-button",
}) {
  const base =
    "inline-flex items-center justify-center select-none transition-transform hover:-translate-y-0.5 active:translate-y-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-moffat-whatsapp focus-visible:ring-offset-2";

  let sizing = "";
  if (variant === "hero") sizing = "h-14";
  if (variant === "inline") sizing = "h-12";
  if (variant === "sm") sizing = "h-10";
  if (variant === "block") sizing = "w-full h-auto max-h-14";

  return (
    <a
      data-testid={testId}
      href={SITE.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className={`${base} ${sizing} ${className}`}
    >
      <img
        src={SITE.whatsappButtonImg}
        alt="Chat on WhatsApp"
        className="h-full w-auto block drop-shadow-md"
        draggable="false"
      />
    </a>
  );
}
